import React from 'react'

import InfoPanelSummary from '../components/InfoPanelSummary'

import { useQuadhashStats } from '../hooks'

import {
  useRouteNearestTrail
} from '../api'

const InfoPanelQuadhashSummary = (props) => {
  const { icons, elevation, quadhash, route_id, trail_id: current_trail_id } = props
  const { trail_id } = useRouteNearestTrail({
    routeId: route_id,
    quadhash: quadhash
  }, { skip: !!current_trail_id || !quadhash }) || {}

  const { distance_from_trail, length, time, trail_id: near_trail_id } = useQuadhashStats({
    quadhash: quadhash,
    route_id: route_id,
    trail_id: trail_id || current_trail_id
  }) || {}

  if (!near_trail_id) return null

  return <InfoPanelSummary icons={icons}
                           distance_from_trail={distance_from_trail}
                           length={length}
                           time={time}
                           route_id= {route_id}
                           trail_id = {near_trail_id}
                           elevation={elevation} />
}

export default InfoPanelQuadhashSummary
